module.exports = __webpack_public_path__ + "img/image-1.f85797e1.svg";